module.exports = __webpack_public_path__ + "static/media/lecker.36f5f267.mp3";